/*
 * Ergovanta DTC product gallery: thumbnail-strip scroll affordance (2026-06-22)
 *
 * The Horizon product carousel renders its thumbnails (when the gallery block
 * uses slideshow_controls_style: "thumbnails", thumbnail_position: "bottom")
 * inside a horizontally scrollable <scroll-hint class="slideshow-controls__
 * thumbnails-container"> within <slideshow-controls pagination-position="center"
 * thumbnails>. The strip scrolls but gives no signal that more thumbnails exist.
 *
 * This script, for each bottom (horizontal) thumbnail strip:
 *   - injects an accessible navy prev/next arrow pill (decorative chrome; the
 *     real thumbnail <button>s keep working for keyboard + click selection),
 *   - toggles [data-eg-thumb-overflow] on the scroll container and
 *     [data-eg-thumb-edge="start end"] on the controls host so eg-overrides.css
 *     can fade/show the right affordance for the current scroll position,
 *   - re-evaluates on scroll, resize, and Shopify section / variant re-renders.
 *
 * It NEVER hijacks the thumbnail buttons' own click handlers and adds no new
 * focus traps; arrows are supplementary. Reversible: remove the <script> include
 * in layout/theme.liquid + this asset + the DTC block in eg-overrides.css.
 */
(function () {
  'use strict';

  var ARROW_PREV =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ARROW_NEXT =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // Tolerance so sub-pixel rounding doesn't leave an arrow stuck visible.
  var EDGE_TOLERANCE = 2;

  function makeArrow(dir, container) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'eg-thumb-arrow eg-thumb-arrow--' + dir;
    btn.setAttribute('tabindex', '-1'); // chrome only; thumbnails carry the real focus order
    btn.setAttribute(
      'aria-label',
      dir === 'prev' ? 'Scroll thumbnails left' : 'Scroll thumbnails right'
    );
    btn.innerHTML = dir === 'prev' ? ARROW_PREV : ARROW_NEXT;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      // Scroll by ~75% of the visible width, one "page" of thumbnails.
      var amount = Math.max(120, container.clientWidth * 0.75);
      container.scrollBy({ left: dir === 'prev' ? -amount : amount, behavior: 'smooth' });
    });
    return btn;
  }

  function updateEdges(host, container) {
    var max = container.scrollWidth - container.clientWidth;
    var overflowing = max > EDGE_TOLERANCE;
    if (!overflowing) {
      container.removeAttribute('data-eg-thumb-overflow');
      host.removeAttribute('data-eg-thumb-edge');
      return;
    }
    container.setAttribute('data-eg-thumb-overflow', '');
    var x = container.scrollLeft;
    var edges = [];
    if (x > EDGE_TOLERANCE) edges.push('start'); // can scroll back -> show prev + left fade
    if (x < max - EDGE_TOLERANCE) edges.push('end'); // can scroll forward -> show next + right fade
    host.setAttribute('data-eg-thumb-edge', edges.join(' '));
  }

  function initHost(host) {
    if (host.__egThumbScrollInit) return;
    // Only the bottom/center horizontal strip; skip vertical left/right layouts.
    if (host.getAttribute('pagination-position') !== 'center') return;
    var container = host.querySelector('.slideshow-controls__thumbnails-container');
    if (!container) return;
    host.__egThumbScrollInit = true;

    host.appendChild(makeArrow('prev', container));
    host.appendChild(makeArrow('next', container));

    var raf = null;
    var schedule = function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        updateEdges(host, container);
      });
    };

    container.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(schedule);
      ro.observe(container);
      var inner = container.querySelector('.slideshow-controls__thumbnails');
      if (inner) ro.observe(inner);
    }

    // Images may still be loading; recheck once they settle.
    Array.prototype.forEach.call(container.querySelectorAll('img'), function (img) {
      if (!img.complete) img.addEventListener('load', schedule, { once: true });
    });

    updateEdges(host, container);
  }

  function initAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(
      root.querySelectorAll('slideshow-controls[thumbnails]'),
      initHost
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor re-renders + Horizon variant swaps that re-render the gallery.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { initAll(e.target); });
})();
